<div class="error-server-container">
    <div class="flex jc-c ai-c">
        <img src="assets/images/error.svg" alt="" />
    </div>
    <div class="dark mapfre-fs-s mapfre-mt-sm text">
        ¡Ups! parece que hay un problema. Por favor, inténtelo de nuevo más tarde
    </div>
    
    <div class="flex jc-e mapfre-mt-m">
        <app-button pixelWidth="255"  fw="700" fs=16 type="primary" size="medium"
            (click)="ui.closeAllDialogs()" text="Entendido">
        </app-button>
    </div>
</div>